import CheatMenu from './CheatMenu';
import { connect } from '../../node_modules/react-redux';

var mapStateToProps = function mapStateToProps(state) {
  return {
    useProd: state.apiRootIndex.useProd
  };
};

export default connect(mapStateToProps, null)(CheatMenu);